import { Result } from "@cartographerio/fp";
import { isPoint } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isTimestamp } from "@cartographerio/types";
import { midpoint } from "@turf/midpoint";
export function isPartialData(data) {
    return (isObject(data) &&
        hasKey(data, "general", isCesGeneralInformation) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)));
}
function isCesGeneralInformation(data) {
    return isObject(data) && hasKey(data, "location", isCesSurveyLocation);
}
function isCesSurveyLocation(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "canalNameCode", isNullable(isString)) &&
        hasOptionalKey(data, "canalKmCode", isNullable(isString)) &&
        hasOptionalKey(data, "startMarker", isNullable(isString)) &&
        hasOptionalKey(data, "startLocation", isNullable(isPoint)) &&
        hasOptionalKey(data, "endMarker", isNullable(isString)) &&
        hasOptionalKey(data, "endLocation", isNullable(isPoint)));
}
export function dataDescription(data) {
    return Result.guard(isPartialData, "PartialCanalEnvironmentSurveyData")(data).map(data => {
        const location = data.general.location;
        if (location.startMarker != null && location.endMarker != null) {
            return `${location.startMarker} to ${location.endMarker}`;
        }
        else if (location.canalNameCode != null && location.canalKmCode != null) {
            return `${location.canalNameCode} (${location.canalKmCode})`;
        }
        else {
            return (location.canalNameCode ?? location.canalKmCode ?? "Unknown location");
        }
    });
}
export function dataGeometry(data) {
    return Result.guard(isPartialData, "PartialCanalEnvironmentSurveyData")(data).map(data => data.general.location.startLocation != null &&
        data.general.location.endLocation != null
        ? midpoint(data.general.location.startLocation, data.general.location.endLocation).geometry
        : data.general.location.startLocation ??
            data.general.location.endLocation ??
            null);
}
export function dataTimestamp(data) {
    return Result.guard(isPartialData, "PartialCanalEnvironmentSurveyData")(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return Result.guard(isPartialData, "PartialCanalEnvironmentSurveyData")(data).map(data => ({
        ...data,
        general: { ...data.general, location: {} },
    }));
}
//# sourceMappingURL=parts.js.map